/**
 * Created by hernanherreros on 2019-04-30
 */

import * as React from 'react'
import styled from 'styled-components'
import Header from './Header'

import withCongress, { ComponentProps } from '../../providers/Congress/withCongress'
import LanguageSelector from './LanguageSelector'
import { flowRight } from 'lodash'
import withURLParams, { URLParamsComponentProps } from '../../providers/URLParams/withURLParams'

interface Props extends ComponentProps, URLParamsComponentProps {
}

interface State {
  isEmbed: boolean;
}

class Layout extends React.Component<Props, State> {
  state = {
    isEmbed: false,
  }

  componentWillMount () {
    const { params } = this.props

    this.setState({
      isEmbed: params.embed === '' || !!params.embed
    })
  }

  render () {
    const { isEmbed } = this.state
    const { children, congress } = this.props

    const headerHeight = isEmbed ? '100px' : '140px'
    const paddingTop = isEmbed ? '0' : '120px'

    return (
      <Container>
        <Header isEmbed={isEmbed} height={headerHeight}/>
        <Wrapper embed={isEmbed} paddingTop={paddingTop}>
          {congress.Slug !== 'veterinario2019' && <LanguageSelector responsive={true} embed={isEmbed}/>}
          {children}
        </Wrapper>
      </Container>
    )
  }
}

export default flowRight([ withCongress, withURLParams ])(Layout)

const Container = styled.div`
  padding-bottom: 100px;
`

const Wrapper = styled.div<any>`
  ${({ paddingTop }) => `padding-top: ${paddingTop};`}

`
